<template>
  <div>
     <div class="title">
        <span class="link">服务管理 ></span> <span class="curLink">
          {{ menuTab[activeMenu].name}}
        </span>   
     </div>
     <div class="content">
       <div class="tabList">
            <div class="tab" v-for="(item, index) in menuTab" :key="index" @click="topTabMenu(item, index)"
              :class="{'activeIndex': activeMenu == index}">
              {{item.name}}
            </div>
        </div>
        <div class="pageList">
          <template v-if="activeMenu === 0">
            <AuthorizedServe />
          </template>
          <template v-else-if="activeMenu === 1">
            <ServiceMarket />
          </template>
    </div>
     </div>
  </div>
</template>
<script>
import { fetchInterfaceTypeList, fetchInterfaceList, fetchInterfaceApply } from '@/api/api'
import Nodata from '@/components/noData.vue'
import AuthorizedServe from './components/AuthorizedServe.vue'
import ServiceMarket from './components/ServiceMarket.vue'
export default {
  data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 10,
      list: [],
      tabList:[
        {
          typeName:'全部',
          id: 'all',
        },
      ],
      ptIndex: 'all',

       menuTab: [
          {
              name: '授权接口'
          },
          {
              name: '接口市场'
          },
        ],
        activeMenu: 0,
      
    }
  },
  created() {
    this.getTypeList()
    this.getList()
  },
  components:{
      Nodata,
      AuthorizedServe,
      ServiceMarket
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    getList() {
      let params = {
        pageNum: this.pageNum-1,
        pageSize: this.pageSize,
      }
      if(this.ptIndex === 'all') {
        params.typeId = ''
      }else {
        params.typeId = this.ptIndex  
      }
      fetchInterfaceList(params).then(res => {
        this.list = res.data.content
        this.total = Number(res.data.totalElements)
      })
    },
    
    getMethText(num) {
      let str = ''
      if(num === 1) {
        str='POST'
      }else if(num === 2) {
        str='GET'
      }else if(num === 3) {
        str='PUT'
      }else if(num === 4) {
        str='DELETE'
      }
      return str
    },
    getTypeList() {
      fetchInterfaceTypeList().then(res => {
          this.tabList = [...this.tabList, ...res.data]
      })
    },
    changeData(idx, id) {
        this.ptIndex = id
        this.pageNum = 1
        this.getList()
    },
    handleOpen(id) {
      let params={
          id: id
      }
      fetchInterfaceApply(params).then(res => {
        if(res.code == 1) {
          this.$message.success('申请成功');
        }else {
          this.$message.error(res.msg);
        }
      })
    },
    topTabMenu(item, index) {
      this.activeMenu = index
    },
  }
}
</script>
<style scoped>
.title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282F3D;
    padding-left: 30px;
    background: #fff;
  }
  .curLink{
    cursor: pointer;
  }
  .link{
    color: rgba(144, 157, 177, 1);
  }
  .content {
    box-sizing: border-box;
    padding: 20px 20px 10px;
  }
  .pageList {
    width: 100%;
    height: calc(100vh - 220px);
    background: #FFFFFF;
    box-shadow: 1px 3px 16px 0px rgba(204, 211, 228, 0.51);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px 40px;
    /* border: 1px solid #000; */
  }

  .pageBox{
    display: flex;
    justify-content: flex-end;
  }
  .downBtn{
    color: #0F5EFF;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .lookBtn{
    color: #0ECEC3;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .downBtn img, .lookBtn img{
    width: 12px;
    height: 14px;
    margin-right: 3px;
  }
  .btns{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }



/**上面选项卡 */
.tabList {
    height: 42px;
    /* display: flex; */
    /* justify-content: flex-start; */
    padding-right: 20px;
    /* border-bottom: 1px solid #909DB1; */
    padding: 0 20px 0;
  }

  .tabList>div.tab {
    cursor: pointer;
    width: 100px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #909DB1;
    text-align: center;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    /* border-bottom: 2px solid transparent; */
  }
  .tabList>div.tab.activeIndex {
    border-bottom: 2px solid #225EFD;
    color: #225EFD;
  }
  

</style>


// WEBPACK FOOTER //
// src/views/console/ServiceMarket.vue